import { Trans, useTranslation } from "react-i18next";
import { MaxWidthContainer } from "../../generic/layout/maxWidthContainer";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

export function UnpluggedLandingComponent() {
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;

  //navigate with react router automatically to subpage /unplugged/arbitrator-interviews upon page load
  useEffect(() => {
    navigate(`/${currentLanguage}/unplugged/arbitrator-interviews`);
  }, [navigate, currentLanguage]);

  return <MaxWidthContainer></MaxWidthContainer>;
}
